import { useEffect, useState } from "react"
import { Box, ScrollArea, Tabs as TabsRadix } from "@radix-ui/themes"

type tabsProps = {
  children: (any | undefined)[]
  activeTabIdent?: string
  onChange?: (ident: string) => void
  isVertical?: boolean
  height?: string
}
export const Tabs = ({
  children,
  activeTabIdent: activeIdent,
  onChange,
  isVertical,
  height,
}: tabsProps) => {
  const [activeTabIdent, setActiveTabIdent] = useState(children[0]?.props.ident)
  useEffect(() => {
    const tab = children.find((tab) => tab?.props?.ident === activeIdent)
    if (tab && tab.props.ident !== activeTabIdent) {
      setActiveTabIdent(tab.props.ident)
    } else if (!tab) {
      const firstTabIdent = children[0]?.props.ident
      setActiveTabIdent(firstTabIdent)
    }
  }, [activeIdent, children])

  const heightContent = `calc(${height || "100%"}${
    isVertical ? "" : " - 40px"
  } - 12px)`

  return (
    <TabsRadix.Root
      value={activeTabIdent}
      onValueChange={(ident) => {
        setActiveTabIdent(ident)
        onChange && onChange(ident)
      }}
      orientation={isVertical ? "vertical" : "horizontal"}
      style={
        isVertical
          ? {
              display: "grid",
              gridTemplateColumns: "1fr 4fr",
              gap: "12px",
              alignItems: "flex-start",
              height,
            }
          : { height }
      }
    >
      <TabsRadix.List
        justify="center"
        wrap="wrap"
        size="2"
        className="flex mt-6 md:flex-col md:items-start md:space-y-2 md:mt-12"
        style={
          isVertical
            ? {
                display: "flex",
                marginTop: "1.5rem",
                flexDirection: "column",
              }
            : {}
        }
      >
        {children.map((TabEl, i) => {
          if (!TabEl) return null
          return (
            <TabsRadix.Trigger
              key={"tabBtn" + TabEl.props.name + i}
              value={TabEl.props.ident}
              style={
                isVertical
                  ? { boxShadow: "inset 0 -1px 0 0 var(--gray-a5)" }
                  : {}
              }
            >
              {TabEl.props.name}
            </TabsRadix.Trigger>
          )
        })}
      </TabsRadix.List>
      <Box pt={isVertical ? "0" : "3"}>
        <ScrollArea
          style={{
            height: heightContent,
          }}
        >
          {children}
        </ScrollArea>
      </Box>
    </TabsRadix.Root>
  )
}
